import helper from 'store/helper';
import types from './types';

const checkAdebifyFeature = () =>
  helper.createAction(types.CHECK_ADEBIFY_FEATURE);

const setAdebifyEnabled = (isEnabled) =>
  helper.createAction(types.SET_ADEBIFY_ENABLED, { isEnabled });

const setAdebifyLoading = (isLoading) =>
  helper.createAction(types.SET_ADEBIFY_LOADING, { isLoading });

export default {
  checkAdebifyFeature,
  setAdebifyEnabled,
  setAdebifyLoading,
};
